module.exports = __webpack_public_path__ + "static/media/picture_vladimir.6e416e97.jpg";